// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { UIModelComponent } from '../../../../../com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { DBComponent } from '../../../../../com/MetaPattern/MDA/MD/DBModel/DBComponent';
import { PublishCallBackDataDTO } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/PublishCallBackDataDTO';
import { PipelinePublishTask } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/PipelinePublishTask';
import { PipelinePublishPhase } from '../../../../../com/MetaPattern/APP/MDA/Pipeline/PipelinePublishPhase';
import { post, get } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class GenerateCodeDTO {
  aPPKey: string;

  public toJson(): any {
    const json: any = {};
    json.APPKey = this.aPPKey;
    return json;
  }
}
class PublishAPPFullDTO {
  aPPKey: string;

  public toJson(): any {
    const json: any = {};
    json.APPKey = this.aPPKey;
    return json;
  }
}
class APPConvertToUIDTO {
  aPPKey: string;

  public toJson(): any {
    const json: any = {};
    json.APPKey = this.aPPKey;
    return json;
  }
}
class BEToUIModelDTO {
  bEComponentID: string;

  public toJson(): any {
    const json: any = {};
    json.BEComponentID = this.bEComponentID;
    return json;
  }
}
class BEToDBDTO {
  bEComponentID: string;

  public toJson(): any {
    const json: any = {};
    json.BEComponentID = this.bEComponentID;
    return json;
  }
}
class APPConvertToDBDTO {
  aPPKey: string;

  public toJson(): any {
    const json: any = {};
    json.APPKey = this.aPPKey;
    return json;
  }
}
class PublishDBDTO {
  aPPKey: string;

  public toJson(): any {
    const json: any = {};
    json.APPKey = this.aPPKey;
    return json;
  }
}
class PublishProductFullDTO {
  productId: string;
  needCompile: boolean;
  aPPKey: string;
  isTest: boolean;
  includeAPPKeys: Array<string>;
  includeFront: string;

  public toJson(): any {
    const json: any = {};
    json.ProductId = this.productId;
    json.NeedCompile = this.needCompile;
    json.APPKey = this.aPPKey;
    json.IsTest = this.isTest;
    json.IncludeAPPKeys = [];
    this.includeAPPKeys.forEach((item) => {
      json.IncludeAPPKeys.push(item);
    });
    json.includeFront = this.includeFront;
    return json;
  }
}
class PublishCallBackDTO {
  callBackDataDTO: PublishCallBackDataDTO;

  public toJson(): any {
    const json: any = {};
    if (this.callBackDataDTO.toJson) {
      json.CallBackDataDTO = this.callBackDataDTO.toJson();
    } else {
      json.CallBackDataDTO = this.callBackDataDTO;
    }
    return json;
  }
}
/**
 * 流水线服务 服务类
 * 流水线服务
 */
export class PipelineService {
  static async GenerateCodeAsync(aPPKey: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new GenerateCodeDTO();
      dto.aPPKey = aPPKey;
      post('metapattern-ide-mda/service/pipelineservice/generatecode', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishAPPFullAsync(aPPKey: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishAPPFullDTO();
      dto.aPPKey = aPPKey;
      post('metapattern-ide-mda/service/pipelineservice/publishappfull', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async APPConvertToUIAsync(aPPKey: string): Promise<Array<UIModelComponent> | null> {
    return new Promise((resolve, reject) => {
      const dto = new APPConvertToUIDTO();
      dto.aPPKey = aPPKey;
      post('metapattern-ide-mda/service/pipelineservice/appconverttoui', dto.toJson())
        .then((response: any) => {
          let result: Array<UIModelComponent> | null = null;
          if (response) {
            const items = new Array<UIModelComponent>();
            response.forEach((item: any) => {
              const element = UIModelComponent.Create(item);
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async BEToUIModelAsync(bEComponentID: string): Promise<UIModelComponent | null> {
    return new Promise((resolve, reject) => {
      const dto = new BEToUIModelDTO();
      dto.bEComponentID = bEComponentID;
      post('metapattern-ide-mda/service/pipelineservice/betouimodel', dto.toJson())
        .then((response: any) => {
          let result: UIModelComponent | null = null;
          if (response) {
            result = UIModelComponent.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async BEToDBAsync(bEComponentID: string): Promise<DBComponent | null> {
    return new Promise((resolve, reject) => {
      const dto = new BEToDBDTO();
      dto.bEComponentID = bEComponentID;
      post('metapattern-ide-mda/service/pipelineservice/betodb', dto.toJson())
        .then((response: any) => {
          let result: DBComponent | null = null;
          if (response) {
            result = DBComponent.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async APPConvertToDBAsync(aPPKey: string): Promise<Array<DBComponent> | null> {
    return new Promise((resolve, reject) => {
      const dto = new APPConvertToDBDTO();
      dto.aPPKey = aPPKey;
      post('metapattern-ide-mda/service/pipelineservice/appconverttodb', dto.toJson())
        .then((response: any) => {
          let result: Array<DBComponent> | null = null;
          if (response) {
            const items = new Array<DBComponent>();
            response.forEach((item: any) => {
              const element = DBComponent.Create(item);
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishDBAsync(aPPKey: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishDBDTO();
      dto.aPPKey = aPPKey;
      post('metapattern-ide-mda/service/pipelineservice/publishdb', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishProductFullAsync(productId: string, needCompile: boolean, aPPKey: string, isTest: boolean, includeAPPKeys: Array<string>, includeFront: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishProductFullDTO();
      dto.productId = productId;
      dto.needCompile = needCompile;
      dto.aPPKey = aPPKey;
      dto.isTest = isTest;
      dto.includeAPPKeys = includeAPPKeys;
      dto.includeFront = includeFront;
      post('metapattern-ide-mda/service/pipelineservice/publishproductfull', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async CreateDDLAsync(aPPKey: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/pipelineservice/createddl', { aPPKey: aPPKey })
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishCallBackAsync(callBackDataDTO: PublishCallBackDataDTO): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishCallBackDTO();
      dto.callBackDataDTO = callBackDataDTO;
      post('metapattern-ide-mda/service/pipelineservice/publishcallback', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetLastPublishSettingAsync(productDesignId: string, aPPDesignId: string): Promise<PipelinePublishTask | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/pipelineservice/getlastpublishsetting', { productDesignId: productDesignId, aPPDesignId: aPPDesignId })
        .then((response: any) => {
          let result: PipelinePublishTask | null = null;
          if (response) {
            result = PipelinePublishTask.Create(response);
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async GetPublishPhasesByTaskAsync(taskId: string): Promise<Array<PipelinePublishPhase> | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/service/pipelineservice/getpublishphasesbytask', { taskId: taskId })
        .then((response: any) => {
          let result: Array<PipelinePublishPhase> | null = null;
          if (response) {
            const items = new Array<PipelinePublishPhase>();
            response.forEach((item: any) => {
              const element = PipelinePublishPhase.Create(item);
              items.push(element);
            });
            result = items;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
